<mat-grid-list cols="2" rowHeight="100%">
  <mat-grid-tile class="login__form-wrapper">
    <div class="login__panel">
      <div class="login__logo-wrapper">
        <svg
          width="327px"
          height="98px"
          viewBox="0 0 378 115"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          id="Layer_1"
          data-name="Layer 1"
        >
          <defs>
            <style>
              .cls-1 {
                fill: #0093d7;
              }
              .cls-2 {
                fill: #375d77;
              }
              .cls-3 {
                fill: url(#radial-gradient);
              }
              .cls-4 {
                fill: url(#radial-gradient-2);
              }
            </style>
            <radialGradient
              id="radial-gradient"
              cx="26"
              cy="89.68"
              r="31.74"
              gradientTransform="translate(0.29 -0.04)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.12" stop-color="#fefefe"></stop>
              <stop offset="0.66" stop-color="#0093d7"></stop>
              <stop offset="0.97" stop-color="#006db6"></stop>
            </radialGradient>
            <radialGradient
              id="radial-gradient-2"
              cx="14.3"
              cy="59.69"
              r="31.74"
              xlink:href="#radial-gradient"
            ></radialGradient>
          </defs>
          <path
            class="cls-1"
            d="M39.44,64.83l-.19-53.59a47.8,47.8,0,0,0-7.81,2.31l.1,29.77L29.65,48l.19,54.19a47.36,47.36,0,0,0,7.83,2.62l-.12-35.3Z"
          ></path>
          <path
            class="cls-2"
            d="M87,69.34l.06,17.57a48,48,0,0,0-2.11-60l.13,37.83Z"
          ></path>
          <path
            class="cls-1"
            d="M9.77,43.37l0-12.76a48,48,0,0,0,2.09,57.93L11.69,48Z"
          ></path>
          <path
            class="cls-2"
            d="M59.32,69.44l.12,35.46a47.43,47.43,0,0,0,5.92-1.75l-.12-33.76,1.88-4.65L67,13.86A46.77,46.77,0,0,0,57.22,11l.18,53.76Z"
          ></path>
          <path
            class="cls-3"
            d="M36.18,110.19a3.8,3.8,0,1,1-3.79-3.8A3.8,3.8,0,0,1,36.18,110.19Z"
          ></path>
          <path
            class="cls-2"
            d="M66.56,4.8A3.8,3.8,0,1,1,62.76,1,3.8,3.8,0,0,1,66.56,4.8Z"
          ></path>
          <path
            class="cls-1"
            d="M25.53,48l-1.91-4.64-.09-25.81a48,48,0,0,0-5.91,4.37l.07,21.48L15.81,48,15.9,73.6h9.72Z"
          ></path>
          <path
            class="cls-2"
            d="M43.56,64.84l1.91,4.65L45.6,106c1.11.08,2.23.13,3.37.12.85,0,1.71,0,2.55-.07L51.4,69.44l1.88-4.66L53.19,37.3H43.46Z"
          ></path>
          <path
            class="cls-2"
            d="M71.25,64.74l1.91,4.65.1,30a48,48,0,0,0,5.92-4.16l-.09-25.84L81,64.69l-.11-33.83H71.13Z"
          ></path>
          <path
            class="cls-4"
            d="M24.5,80.19a3.8,3.8,0,1,1-3.8-3.81A3.8,3.8,0,0,1,24.5,80.19Z"
          ></path>
          <path
            class="cls-2"
            d="M52.25,30.86a3.8,3.8,0,1,1-3.8-3.81A3.81,3.81,0,0,1,52.25,30.86Z"
          ></path>
          <path
            class="cls-2"
            d="M79.7,24.42a3.8,3.8,0,1,1-3.79-3.81A3.8,3.8,0,0,1,79.7,24.42Z"
          ></path>
          <path
            class="cls-2"
            d="M145.28,46.16c0,.09,0,.23,0,.42s0,.33,0,.42a14.31,14.31,0,0,1-.3,3,10.86,10.86,0,0,1-.89,2.61,13.46,13.46,0,0,1-4.84,5.47A12.76,12.76,0,0,1,132.37,60a12.57,12.57,0,0,1-5.26-1.09,13,13,0,0,1-4.34-3.23,12.65,12.65,0,0,1-2.45-4.08,13.92,13.92,0,0,1-.84-4.84,12.64,12.64,0,0,1,1-5,13.59,13.59,0,0,1,3-4.29,12.09,12.09,0,0,1,4.14-2.75,13.72,13.72,0,0,1,5.06-.9,12.18,12.18,0,0,1,7,2,12.65,12.65,0,0,1,4.56,5.81h-6a7.19,7.19,0,0,0-2.56-2.06,7.67,7.67,0,0,0-3.3-.69A7.29,7.29,0,0,0,127,41.23a8.36,8.36,0,0,0,0,11.41A7.45,7.45,0,0,0,132.55,55a7.48,7.48,0,0,0,6.92-4.58h-9.85V46.16Z"
          ></path>
          <path
            class="cls-2"
            d="M161.68,59.52H148.94V34.35h4.84V55.09h7.9Z"
          ></path>
          <path
            class="cls-2"
            d="M163.25,46.88a13.49,13.49,0,0,1,.56-3.91,12.4,12.4,0,0,1,1.63-3.45,12.85,12.85,0,0,1,10.81-5.67,12.32,12.32,0,0,1,4.82,1,12.88,12.88,0,0,1,4.15,2.78,13.35,13.35,0,0,1,2.86,4.23,12.82,12.82,0,0,1,1,5,13.86,13.86,0,0,1-.92,5.06,12.36,12.36,0,0,1-2.72,4.2,12.22,12.22,0,0,1-4.21,3,12.61,12.61,0,0,1-5,1A13.09,13.09,0,0,1,171,59a12.16,12.16,0,0,1-4.19-3,12.8,12.8,0,0,1-2.66-4.19A13.63,13.63,0,0,1,163.25,46.88Zm5.16-.17a8.58,8.58,0,0,0,.53,3,8.42,8.42,0,0,0,4.21,4.51,7,7,0,0,0,3,.68,7.31,7.31,0,0,0,5.53-2.35,8.2,8.2,0,0,0,2.23-5.87,7.54,7.54,0,0,0-2.25-5.5,7.32,7.32,0,0,0-5.4-2.28,7.66,7.66,0,0,0-5.59,2.27A7.47,7.47,0,0,0,168.41,46.71Z"
          ></path>
          <path
            class="cls-2"
            d="M192.57,59.52V34.35H198a21.85,21.85,0,0,1,2.6.13,7.36,7.36,0,0,1,1.71.44,7,7,0,0,1,3.17,2.43,7,7,0,0,1,.44,6.71A4.21,4.21,0,0,1,204,45.94a5.24,5.24,0,0,1,2.93,2.13A6.57,6.57,0,0,1,208,51.83a8.32,8.32,0,0,1-.66,3.31,7,7,0,0,1-1.8,2.58,7.17,7.17,0,0,1-2.58,1.38,15.12,15.12,0,0,1-4,.42Zm4.72-15.07h.57a5.14,5.14,0,0,0,3-.73,2.54,2.54,0,0,0,1-2.19,2.36,2.36,0,0,0-1-2.08,5.12,5.12,0,0,0-2.95-.67h-.71Zm0,10.64h1.49a5.69,5.69,0,0,0,3.28-.75,2.68,2.68,0,0,0,1-2.33,3.12,3.12,0,0,0-1.1-2.6,5,5,0,0,0-3.22-.88h-1.49Z"
          ></path>
          <path
            class="cls-2"
            d="M216,54.24l-1.95,5.28H209l9.75-25.17H223l9.61,25.17h-5.26l-2-5.28Zm7.69-4.66-3-8.11-3,8.11Z"
          ></path>
          <path
            class="cls-2"
            d="M248.45,59.52H235.71V34.35h4.84V55.09h7.9Z"
          ></path>
          <path
            class="cls-1"
            d="M265.24,59.52h-4.92V34.35h6.25a21.35,21.35,0,0,1,3.74.26,5.82,5.82,0,0,1,2.22.83A7.47,7.47,0,0,1,275,38.22a8,8,0,0,1,.88,3.7,7.42,7.42,0,0,1-2.37,5.77,9.18,9.18,0,0,1-6.41,2.16h-1.83Zm0-13.91h1.29a4.85,4.85,0,0,0,3.15-.89,3.55,3.55,0,0,0,0-5.1,5.14,5.14,0,0,0-3.22-.84h-1.26Z"
          ></path>
          <path
            class="cls-1"
            d="M293.2,59.52H279.64V34.35H293.2v4.43h-8.72v5.75h8.72v4.35h-8.72v6.21h8.72Z"
          ></path>
          <path
            class="cls-1"
            d="M297.34,46.88a13.49,13.49,0,0,1,.55-3.91,12.4,12.4,0,0,1,1.63-3.45,12.89,12.89,0,0,1,10.81-5.67,12.32,12.32,0,0,1,4.82,1,12.78,12.78,0,0,1,4.15,2.78,13.35,13.35,0,0,1,2.86,4.23,12.82,12.82,0,0,1,1,5,13.86,13.86,0,0,1-.92,5.06A12.36,12.36,0,0,1,319.5,56a12.22,12.22,0,0,1-4.21,3,12.58,12.58,0,0,1-5,1,13.09,13.09,0,0,1-5.17-1,12.16,12.16,0,0,1-4.19-3,12.8,12.8,0,0,1-2.66-4.19A13.62,13.62,0,0,1,297.34,46.88Zm5.15-.17a8.58,8.58,0,0,0,.53,3,8.42,8.42,0,0,0,4.21,4.51,7.06,7.06,0,0,0,3,.68,7.3,7.3,0,0,0,5.52-2.35A8.2,8.2,0,0,0,318,46.71a7.54,7.54,0,0,0-2.25-5.5,7.35,7.35,0,0,0-5.41-2.28,7.66,7.66,0,0,0-5.59,2.27A7.47,7.47,0,0,0,302.49,46.71Z"
          ></path>
          <path
            class="cls-1"
            d="M332.34,59.52h-4.92V34.35h6.25a21.56,21.56,0,0,1,3.75.26,5.83,5.83,0,0,1,2.21.83,7.38,7.38,0,0,1,2.44,2.78,8,8,0,0,1,.89,3.7,7.43,7.43,0,0,1-2.38,5.77,9.18,9.18,0,0,1-6.41,2.16h-1.83Zm0-13.91h1.29a4.85,4.85,0,0,0,3.15-.89,3.55,3.55,0,0,0,0-5.1,5.14,5.14,0,0,0-3.22-.84h-1.26Z"
          ></path>
          <path
            class="cls-1"
            d="M359.49,59.52H346.74V34.35h4.84V55.09h7.91Z"
          ></path>
          <path
            class="cls-1"
            d="M377,59.52H363.44V34.35H377v4.43h-8.72v5.75H377v4.35h-8.72v6.21H377Z"
          ></path>
          <rect
            class="cls-2"
            x="107.42"
            y="7.21"
            width="1.24"
            height="99.42"
          ></rect>
          <path
            class="cls-2"
            d="M119.46,75.74h2.78V76a2.32,2.32,0,0,0,.51,1.57,1.69,1.69,0,0,0,1.35.59,1.88,1.88,0,0,0,1.44-.55,2,2,0,0,0,.53-1.48c0-1-.72-1.71-2.16-2.14l-.43-.13a5.58,5.58,0,0,1-2.68-1.6,3.87,3.87,0,0,1-.87-2.6,4.93,4.93,0,0,1,1.2-3.47,4.15,4.15,0,0,1,3.21-1.31,4,4,0,0,1,3,1.16,5.06,5.06,0,0,1,1.24,3.27h-2.74v-.13a1.62,1.62,0,0,0-.45-1.2,1.51,1.51,0,0,0-1.16-.46,1.47,1.47,0,0,0-1.17.47,1.78,1.78,0,0,0-.43,1.27,1.85,1.85,0,0,0,.09.6,1.34,1.34,0,0,0,.28.47,4.18,4.18,0,0,0,1.87.88c.43.11.75.21,1,.29A4.74,4.74,0,0,1,128.21,73a4.19,4.19,0,0,1,.76,2.57,5.39,5.39,0,0,1-1.33,3.82,4.53,4.53,0,0,1-3.53,1.45,4.31,4.31,0,0,1-3.34-1.4A5.37,5.37,0,0,1,119.46,75.74Z"
          ></path>
          <path
            class="cls-2"
            d="M155.34,65.14v2.72h-2.9V80.52h-3V67.86h-2.9V65.14Z"
          ></path>
          <path
            class="cls-2"
            d="M176.64,80.52h-3V65.14h3.66a20.76,20.76,0,0,1,2.62.12,5.06,5.06,0,0,1,1.46.4,4.59,4.59,0,0,1,2,1.7,4.76,4.76,0,0,1,.69,2.58,4.69,4.69,0,0,1-1,3,4.43,4.43,0,0,1-2.69,1.58l3.87,6h-3.62l-4-7.16Zm0-7.93h.67a5,5,0,0,0,2.8-.65,2.19,2.19,0,0,0,.95-1.93,2,2,0,0,0-.8-1.8,4.23,4.23,0,0,0-2.49-.59h-1.13Z"
          ></path>
          <path
            class="cls-2"
            d="M205.09,77.29l-1.2,3.23h-3.15l6-15.38h2.62l5.92,15.38h-3.24l-1.23-3.23Zm4.74-2.83-1.82-5-1.87,5Z"
          ></path>
          <path
            class="cls-2"
            d="M239.59,65.14v2.72H236.7V80.52h-3V67.86h-2.89V65.14Z"
          ></path>
          <path
            class="cls-2"
            d="M266.26,80.52h-8.38V65.14h8.38v2.72H260.9v3.49h5.36V74H260.9V77.8h5.36Z"
          ></path>
          <path
            class="cls-2"
            d="M300.83,72.36c0,.06,0,.14,0,.26s0,.2,0,.26a8.9,8.9,0,0,1-.18,1.84,6.72,6.72,0,0,1-.55,1.6,8.15,8.15,0,0,1-3,3.33,7.86,7.86,0,0,1-4.27,1.18,7.73,7.73,0,0,1-3.24-.67,7.92,7.92,0,0,1-2.68-2,7.71,7.71,0,0,1-1.51-2.5,8.31,8.31,0,0,1-.53-3,7.57,7.57,0,0,1,.63-3,8.27,8.27,0,0,1,1.84-2.62,7.29,7.29,0,0,1,2.56-1.68,8.41,8.41,0,0,1,3.12-.55,7.5,7.5,0,0,1,4.31,1.22,7.83,7.83,0,0,1,2.81,3.55h-3.68a4.49,4.49,0,0,0-1.58-1.25,4.83,4.83,0,0,0-2-.42,4.51,4.51,0,0,0-3.37,1.43,5,5,0,0,0,0,6.94A4.62,4.62,0,0,0,293,77.72a4.63,4.63,0,0,0,4.28-2.8h-6.08V72.36Z"
          ></path>
          <path class="cls-2" d="M319.59,80.52V65.14h3V80.52Z"></path>
          <path
            class="cls-2"
            d="M341.12,75.74h2.78V76a2.32,2.32,0,0,0,.51,1.57,1.71,1.71,0,0,0,1.36.59,1.91,1.91,0,0,0,1.44-.55,2,2,0,0,0,.53-1.48c0-1-.72-1.71-2.16-2.14l-.44-.13a5.63,5.63,0,0,1-2.68-1.6,3.87,3.87,0,0,1-.87-2.6,4.89,4.89,0,0,1,1.21-3.47A4.12,4.12,0,0,1,346,64.83,4,4,0,0,1,349,66a5,5,0,0,1,1.24,3.27H347.5v-.13a1.66,1.66,0,0,0-.44-1.2,1.55,1.55,0,0,0-1.17-.46,1.49,1.49,0,0,0-1.17.47,1.78,1.78,0,0,0-.43,1.27,1.85,1.85,0,0,0,.09.6,1.5,1.5,0,0,0,.28.47,4.23,4.23,0,0,0,1.88.88c.42.11.75.21,1,.29A4.65,4.65,0,0,1,349.87,73a4.13,4.13,0,0,1,.76,2.57,5.39,5.39,0,0,1-1.33,3.82,4.53,4.53,0,0,1-3.52,1.45,4.32,4.32,0,0,1-3.35-1.4A5.37,5.37,0,0,1,341.12,75.74Z"
          ></path>
          <path
            class="cls-2"
            d="M377,65.14v2.72h-2.89V80.52h-3V67.86H368.2V65.14Z"
          ></path>
        </svg>
      </div>
      <p *ngIf="redirecting" class="login__intro">Taking you to sign in...</p>
      <div *ngIf="!redirecting" class="login__workos-wrapper">
        <a mat-flat-button color="accent" (click)="loginWithWorkOS()"
          >Sign in to GPS</a
        >
      </div>
      <div class="login__error-wrapper">
        <mat-error
          ><div *ngIf="error">{{ error }}</div></mat-error
        >
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="login__content-wrapper"> </mat-grid-tile>
</mat-grid-list>
